import { normalizeArtifactRef } from 'flare-chat-core/contracts/context/artifact-ref';

const identity = (ref) => [ref.scope?.tenant_id, ref.scope?.project_id, ref.artifact_id,
  ref.artifact_version_id, ref.artifact_type, ref.content_digest];
const sameReference = (left, right) => JSON.stringify(identity(left ?? {})) === JSON.stringify(identity(right ?? {}));

/** Translate committed delivery records only; prose and templates cannot establish a saved asset. */
export const buildCommittedArtifactItems = ({ deliveredArtifacts, conversationProjection, roundKey = '' } = {}) => {
  const citations = (Array.isArray(conversationProjection?.artifact_presentations) ? conversationProjection.artifact_presentations : [])
    .filter((entry) => entry?.presentation_kind === 'citation');
  const cards = (Array.isArray(deliveredArtifacts) ? deliveredArtifacts : []).flatMap((delivery) => {
    let ref;
    try { ref = normalizeArtifactRef(delivery?.artifact_ref); } catch { return []; }
    if (![delivery.semantic_id, delivery.title].every((value) => typeof value === 'string' && value.trim())
      || (delivery.publication_metadata && !sameReference(delivery.publication_metadata.artifact_ref, ref))
      || citations.some((entry) => sameReference(entry.artifact_ref, ref))) return [];
    return [{ id: `artifact-delivery:${JSON.stringify([roundKey, ...identity(ref)])}`,
      type: 'message_artifact', presentation_kind: 'committed_artifact', roundKey,
      title: delivery.title, artifact_id: ref.artifact_id, artifact_type: ref.artifact_type,
      artifact_ref: ref, ...(delivery.publication_metadata ? { publication_metadata: delivery.publication_metadata } : {}),
      can_open: true, can_download: false,
      action: { type: 'open_artifact_document', artifact_target: {
        project_id: ref.scope.project_id, artifact_id: ref.artifact_id,
        artifact_version_id: ref.artifact_version_id, artifact_type: ref.artifact_type, content_digest: ref.content_digest,
      } } }];
  });
  return [...new Map(cards.map((card) => [card.id, card])).values()];
};
